import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PubnubPresenceEvent } from 'src/app/shared/pubnub/pubnub-types';
import { AppState } from 'src/store/appstate';
import { selectPubnubPresence } from 'src/store/pubnub/pubnub-store.model';

@Component({
  selector: 'tcs-pubnub-presence',
  templateUrl: './pubnub-presence.component.html',
  styleUrls: ['./pubnub-presence.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PubnubPresenceComponent {
  public presence$: Observable<PubnubPresenceEvent | null>;

  constructor(store: Store<AppState>) {
    this.presence$ = store.select(selectPubnubPresence());
  }
}
